<div
  class="col-md-12"
  *ngrxLet="{
    clearSearch: (sharedFacade.isClearSearch$ | async),
    selectedOrg: (userDetailsFacade.selectedOrg$ | async)
  } as data"
>
  <piqet-angular-portlet
    [columnDefs]="columnDefs"
    [frameworkComponents]="frameworkComponents"
    [gridData]="packagingProjects"
    [pageNo]="$any(packagingProjects)?.draw"
    (openBtnModal)="addNewProject(0, 'Add new project')"
    [gridName]="gridName"
    [class]="'fixedHeight'"
    [headerBtn]="'Add new packaging project'"
    [importBtn]="organizationNames?.includes(data.selectedOrg) ? 'Import project' : ''"
    [createAccess]="createAccess"
    [isClearSearch]="data?.clearSearch"
    (redirectToImportProject)="redirectToImportProject()"
    (guidedTourPrevEvent)="onPrevStep()"
    [eleId]="eleId"
    [stepCount]="stepCount"
    [stepPos]="'top'"
    [stepTitle]="stepTitle"
    [stepText]="stepText"
  ></piqet-angular-portlet>
  <hr class="hr" />
</div>
